import {
    Box,
    Paper,
    Typography,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    FormControlLabel,
    Switch,
    Divider,
} from "@mui/material";
import {
    TextFields as TextFieldsIcon,
    ArrowDropDown as SelectIcon,
    CheckBox as CheckboxIcon,
    RadioButtonChecked as RadioIcon,
    ToggleOn as SwitchIcon,
    CalendarToday as DateIcon,
    AttachFile as FileIcon,
    Numbers as NumberIcon,
    Email as EmailIcon,
    Phone as PhoneIcon,
    DragIndicator as DragIcon,
} from "@mui/icons-material";
import { Controller, useFormContext } from "react-hook-form";

export default function SideBar({
    possuiEdicao
}: SideBarProps) {

    const { control } = useFormContext();

    return (
        <Paper sx={{ p: 2 }}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
                Componentes
            </Typography>

            {!possuiEdicao && (
                <Box sx={{ p: 1, backgroundColor: '#fff3cd', borderRadius: 1, border: '1px solid #ffc107' }}>
                    <Typography variant="caption" color="warning.dark">
                        ⚠️ Modo somente leitura
                    </Typography>
                </Box>
            )}

            <List>
                {tiposInputs.map((tipo) => (
                    <ListItem
                        component={'button'}
                        key={tipo.id}
                        sx={{
                            border: '1px solid #e0e0e0',
                            borderRadius: 1,
                            mb: 1,
                            cursor: possuiEdicao ? 'grab' : 'not-allowed',
                            opacity: possuiEdicao ? 1 : 0.6,
                            backgroundColor: possuiEdicao ? 'transparent' : '#f5f5f5',
                            '&:hover': possuiEdicao ? {
                                backgroundColor: '#f5f5f5',
                                borderColor: '#1976d2'
                            } : {}
                        }}
                        disabled={!possuiEdicao}
                    >
                        <ListItemIcon sx={{ minWidth: 40 }}>
                            {tipo.icon}
                        </ListItemIcon>
                        <ListItemText
                            primary={tipo.nome}
                            primaryTypographyProps={{
                                variant: 'body2',
                                fontWeight: 500,
                                color: possuiEdicao ? 'inherit' : 'text.disabled'
                            }}
                        />
                        <DragIcon 
                            color={possuiEdicao ? "action" : "disabled"} 
                            fontSize="small" 
                        />
                    </ListItem>
                ))}
            </List>

            <Divider sx={{ my: 2 }} />

            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold' }}>
                Configurações Gerais
            </Typography>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Controller
                    control={control}
                    name="config.ativar_formulario"
                    render={({ field }) => (
                        <FormControlLabel
                            disabled={!possuiEdicao}
                            control={
                                <Switch
                                    size="small"
                                    checked={field.value}
                                    onChange={possuiEdicao ? (event) => field.onChange(event.target.checked) : undefined}
                                    disabled={!possuiEdicao}
                                />
                            }
                            label={
                                <Typography 
                                    variant="subtitle2" 
                                    color={possuiEdicao ? "text.secondary" : "text.disabled"}
                                >
                                    Ativar Formulário
                                </Typography>
                            }
                        />)
                    }
                />
            </Box>
        </Paper>
    )
}

const tiposInputs = [
    { id: 'text', nome: 'Campo de Texto', icon: <TextFieldsIcon /> },
    { id: 'number', nome: 'Campo Numérico', icon: <NumberIcon /> },
    { id: 'email', nome: 'Email', icon: <EmailIcon /> },
    { id: 'phone', nome: 'Telefone', icon: <PhoneIcon /> },
    { id: 'select', nome: 'Lista Suspensa', icon: <SelectIcon /> },
    { id: 'checkbox', nome: 'Checkbox', icon: <CheckboxIcon /> },
    { id: 'radio', nome: 'Radio Button', icon: <RadioIcon /> },
    { id: 'switch', nome: 'Switch', icon: <SwitchIcon /> },
    { id: 'date', nome: 'Data', icon: <DateIcon /> },
    { id: 'file', nome: 'Upload de Arquivo', icon: <FileIcon /> },
];

interface SideBarProps {
    possuiEdicao: boolean;
}